/* eslint-disable import/prefer-default-export */
export const reverseLatLong = {
  methods: {
    reverseLatLong(coordinates) {
      return coordinates.map(c => c.reverse());
    }
  }
}
